import { Button } from "@heroui/button";
import { isRouteErrorResponse, Link, useNavigate } from "@remix-run/react";
import { useState } from "react";
import { FaDiscord } from "react-icons/fa";

export const ErrorBoundaryUI = ({ error }: { error: unknown }) => {
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();
  const getErrorDetails = () => {
    if (isRouteErrorResponse(error)) {
      return (
        <div className="space-y-4 text-center">
          <h1 className="text-2xl font-bold text-red-600">
            {error.status} - {error.statusText}
          </h1>
          <p className="text-gray-700">{error.data}</p>
        </div>
      );
    } else if (error instanceof Error) {
      return (
        <div className="space-y-4">
          <p className="text-lg text-center font-semibold text-red-600">
            {error.message}
          </p>
          <details className="bg-gray-100 p-4 rounded-md shadow-md">
            <summary className="cursor-pointer text-black">
              View Stack Trace
            </summary>
            <pre className="mt-2 text-sm text-gray-700 overflow-x-auto">
              {error.stack}
            </pre>
          </details>
        </div>
      );
    } else {
      return <pre>{JSON.stringify(error, null, 2)}</pre>;
    }
  };
  return (
    <div className="flex flex-col items-center w-full py-20 px-4">
      <h1 className="font-bangers text-3xl">Opps</h1>
      <p className="opacity-70 text-center">
        Something went wrong, let us know ASAP
      </p>
      <div className="flex flex-row items-center gap-4 mt-4 text-4xl">
        <p>👉</p>
        <Link
          to="https://discord.gg/h3usDWEwY8"
          target="_blank"
          rel="noreferrer"
        >
          <FaDiscord className="w-12 h-12" />
        </Link>
        👈
      </div>
      <p className="opacity-70 text-center mt-2">Or try refreshing the page</p>

      <Button
        size="sm"
        color="primary"
        className="mt-4"
        onPress={() => {
          window.location.reload();
        }}
      >
        Refresh
      </Button>

      <Button
        size="sm"
        color="secondary"
        className="mt-2"
        onPress={() => {
          navigate("/");
        }}
      >
        Go Home
      </Button>

      <Button
        className="mt-2"
        size="sm"
        onPress={() => setShowError(!showError)}
      >
        {showError ? "Hide Error" : "Show Error"}
      </Button>
      {showError && (
        <div className="mt-4 text-wrap w-full">{getErrorDetails()}</div>
      )}
    </div>
  );
};
